import type { IView } from '@barba/core';
import reveal from '../animations/reveal';
import type { ContentList as ContentListType } from '@chipsadesign/content-list';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import { fetchContentList, fetchContentListFilter } from '../dynamic-modules';

const beforeEnterQueue = new IdleQueue();
let newsEl: HTMLElement | null;
let filterContainer: HTMLElement | null;
let catalog: ContentListType | null;
let header : HTMLElement | null;;

let quantityProducts = document.querySelector<HTMLElement>('.section-catalog__quantity-items');
let products = Array.from(document.querySelectorAll<HTMLElement>('.section-catalog__catalog-item'));

if (quantityProducts) {
    quantityProducts.textContent = `(${products.length})`;
}

export default {
    namespace: 'catalog-page',

    beforeEnter({ next }) {
       // catalogSort.init(next.container);
       // sortSelect.init();

        
        beforeEnterQueue.pushTask(() => {
            newsEl = next.container.querySelector<HTMLElement>('.js-catalog');
            filterContainer = next.container.querySelector<HTMLElement>('.js-catalog-filter');
            header = next.container.querySelector<HTMLElement>('.js-header');
            
            if (newsEl) {
                Promise.all([fetchContentList(), fetchContentListFilter()]).then(([ContentList, ContentListFilter]) => {
                    if (newsEl) {
                        catalog = new ContentList(newsEl, {
                            modules: [ContentListFilter],

                            cacheRequests: true,
                            pushState: false,
                            scrollTo: {
                                el: filterContainer || newsEl,
                                offset: (header ? -header.getBoundingClientRect().height : 0) - 30,
                            },
                            onFetchSuccess: (instance, response) => {
                                if (response.data) {
                                    if (response.data.contentHtml && instance.contentEl) {
                                        instance.contentEl.innerHTML = response.data.contentHtml;
                                        requestAnimationFrame(() => {
                                            if (instance.contentEl) {
                                                reveal.init(instance.contentEl);

                                                let quantityProducts = document.querySelector<HTMLElement>('.section-catalog__quantity-items');
                                                let products = Array.from(document.querySelectorAll<HTMLElement>('.section-catalog__catalog-item'));
                                            
                                                if (quantityProducts) {
                                                    quantityProducts.textContent = `(${products.length})`;
                                                }
                                            }
                                        });
                                    }

                                    if (response.data.nextUrl) {
                                        window.history.pushState(null, '', response.data.nextUrl);
                                    }
                                }

                                
                                
                            },
                            filter: {
                                el: filterContainer,
                                filterOnInputChange: true,
                            },
                        });
                    }
                });
            }
        });
    },

    afterEnter(data) {
        //
    },

    beforeLeave() {
        beforeEnterQueue.clearPendingTasks();

        if (catalog) {
            catalog.destroy();
            catalog = null;
        }
    },

    afterLeave({ current }) {
        //
    },
} as IView;
